import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Credit } from 'src/app/models/credit';
import { User } from 'src/app/models/user';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { LoggingService } from 'src/app/services/logging.service';
import { AddCreditsModal } from '../../../modals/add-credits/add-credits.modal';
import { CreditBundleTypeModel } from './credit-bundle-type.model';

export class BaseSettingsCreditsPageClass {

  totalReservedCredits = 0;
  credits: Credit[] = [];
  filter: string = '';
  user!: User;
  modalRef!: NgbModalRef;
  notificationSettings: string[] = ['EmailLowSigningValueReminderSchedule'];
  creditBundleTypes: CreditBundleTypeModel[] = [];
  get NotAllowedToAddOrDeleteCredits(): boolean {
    return !(this.user !== undefined && (this.user.isSystemAdmin || this.user.isWhitelabelAdmin))
  }
  constructor(protected authenticationService: AuthenticationService,
    protected loggingService: LoggingService,
    protected modalService: NgbModal) {

    this.authenticationService.currentUser.subscribe({
      next: (data: any) => {
        this.user = data;
      },
      error: (error: any) => {
        this.loggingService.logException(error);
      }
    });
  }

  applyFilter(event: Event) {
    this.filter = (event.target as HTMLInputElement).value;
  }


  addCredits() {
    if (this.modalService.hasOpenModals()) return;
    let ngbModalOptions: NgbModalOptions = {
      keyboard: false,
      centered: true,
      size: 'md',
      backdrop: 'static'
    };

    this.modalRef = this.modalService.open(AddCreditsModal, ngbModalOptions);
    this.modalRef.componentInstance.creditbundleTypes = this.creditBundleTypes;
    this.modalRef.componentInstance.user = this.user;
    this.modalRef.componentInstance.saveCreditBundle.subscribe(async (credits: any) => {
      await this.postCredits(credits);
    });
  }

  async postCredits(credits: any) {
    // used in HTML or needed for implementations
  }
  filterSettings(keys: string[]) {
    // used in HTML or needed for implementations
  }
  updateSettings(settings: any) {
    // used in HTML or needed for implementations
  }
  async deleteCreditBundle(event: any) {
    // used in HTML or needed for implementations
  }
  protected getCreditBundles(whitelabel: any) {
    // used in HTML or needed for implementations
  }
}


